var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.99 18.5073C30.99 19.3369 30.3204 20.0067 29.4909 20.0067H27.9718C27.712 23.905 24.4539 27.0037 20.4963 27.0037H18.6974L26.4427 33.3411C27.0823 33.8609 27.1823 34.8105 26.6526 35.4502C26.3528 35.8101 25.923 36 25.4933 36C25.1635 36 24.8237 35.89 24.5439 35.6601L13.5505 26.6639C13.0607 26.2641 12.8709 25.5943 13.0907 24.9946C13.3006 24.3948 13.8703 23.995 14.4999 23.995H20.4963C22.8049 23.995 24.7138 22.2457 24.9636 19.9967H14.4999C13.6704 19.9967 13.0008 19.3269 13.0008 18.4973C13.0008 17.6676 13.6704 16.9979 14.4999 16.9979H24.2341C23.4245 15.7884 22.0554 14.9988 20.4963 14.9988H14.4999C13.6704 14.9988 13.0008 14.329 13.0008 13.4994C13.0008 12.6697 13.6704 12 14.4999 12H29.4909C30.3204 12 30.99 12.6697 30.99 13.4994C30.99 14.329 30.3204 14.9988 29.4909 14.9988H26.4927C26.9424 15.5985 27.3122 16.2782 27.5721 16.9979H29.5009C30.3304 16.9979 31 17.6676 31 18.4973L30.99 18.5073Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/Rupee.6c7adaf6a1dec327b08059ff1bea82aa.svg";
export { ForwardRef as ReactComponent };